import { Flex } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal.js';
import { IAuthorWithContribution } from '@publishing-engine/domain/models/submission';
import { FormFieldAuthors } from '@publishing-engine/domain/types/article.js';
import { AuthorsDisplay } from './AuthorsDisplay.js';

interface Props {
  value?: IAuthorWithContribution[];
  previousValue?: IAuthorWithContribution[];
  onClose: () => void;
  config: FormFieldAuthors;
}

export const AuthorsDiffModal = ({
  value,
  previousValue,
  config,
  onClose
}: Props) => {
  const label = 'Authors';

  const zeroState = (
    <Flex padding={4} backgroundColor="surfaceTertiaryFill">
      No {label} provided
    </Flex>
  );

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={label}>
        <button></button>
        <Flex flexDirection="column" gap={2}>
          {!previousValue?.length ? (
            zeroState
          ) : (
            <AuthorsDisplay
              value={previousValue}
              config={config}
              disableInteractivity
            />
          )}
        </Flex>
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={label}>
        <Flex flexDirection="column" gap={2}>
          {!value?.length ? (
            zeroState
          ) : (
            <AuthorsDisplay
              value={value}
              config={config}
              disableInteractivity
            />
          )}
        </Flex>
      </DiffModal.RightSide>
    </DiffModal>
  );
};
